import { t } from "@redotech/redo-i18n";
import { ConversationPlatform } from "@redotech/redo-support-conversation-protocol-common/conversation-protocol";

export const getRuleChannelLabels = (): Record<
  ConversationPlatform,
  string
> => ({
  [ConversationPlatform.EMAIL]: t("Email"),
  [ConversationPlatform.REDO_CHAT]: t("{{brandName}} chat", {
    brandName: "Redo",
  }),
  [ConversationPlatform.FACEBOOK]: "Facebook",
  [ConversationPlatform.FACEBOOK_COMMENTS]: t("{{integrationName}} comments", {
    integrationName: "Facebook",
  }),
  [ConversationPlatform.INSTAGRAM]: t("{{integrationName}} DM", {
    integrationName: "Instagram",
  }),
  [ConversationPlatform.INSTAGRAM_COMMENTS]: t("{{integrationName}} comments", {
    integrationName: "Instagram",
  }),
  [ConversationPlatform.SMS]: t("SMS"),
  [ConversationPlatform.VOICE]: t("Voice"),
  [ConversationPlatform.ATTENTIVE]: "Attentive",
  [ConversationPlatform.POSTSCRIPT]: "Postscript",
  [ConversationPlatform.TIKTOK]: "TikTok",
  [ConversationPlatform.MOBILE_MESSAGE]: t("Mobile Message"),
});
